import { getPageResourceList } from "../api/generated/wrappers/system";
import { createQueryKeys } from "./create-query-keys";
const pageResourceQueryKeys = createQueryKeys("pageResource", {
    all: () => ({
        queryKey: ["page-resource-list"],
        queryFn: getPageResourceList,
    }),
});
export default pageResourceQueryKeys;
